import withService from './withService'

const $ServiceIcon = ({ index, slideIndex, item, service, selected, onClick }) => {
    const activeClass = selected ? 'active' : ''
    const classNames = 'col text-center'

    const onIconClicked = () => {
        onClick(index, slideIndex)
    }

    return (
        <div className={`${classNames} ${activeClass}`} onClick={onIconClicked}>
            <Image className="d-inline-block" image={item.icon} alt={service.name} />
            <span className="clearfix" />

            <h3 className="font-weight-bold d-inline-block">{service.name}</h3>
            <span className="selection-marker" />
        </div>
    )
}
const ServiceIcon = withService($ServiceIcon)

export default ServiceIcon
